export default __webpack_public_path__ + "static/media/anthem-website-logos_linkedin.7236a9f8.webp";